// extracted by mini-css-extract-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Welcome-absolute-center","text":"onfido-sdk-ui-Welcome-text"};